// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-hour-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.work-hour-header {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 10px;
    background-color: #fff;
}

.work-hour-header h3 {
    font-size: 1.4rem;
    text-align: start;
    font-weight: bold;
    color: #333;
    
}

.work-hour-header span {
    font-size: 1rem;
    color: #999; 
}

.work-hour-view-options {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 10px;
}
  
.work-hour-view-options button {
    background: none;
    border: none;
    font-size: 12px;
    cursor: pointer;
    padding: 5px 0px;
    position: relative;
    transition: color 0.3s ease;
    color: black;
}
  
.work-hour-view-options button.active {
    color: #0033cc; 
    font-weight: bold;
}
  
.work-hour-view-options button:not(:last-child)::after {
    content: "";
    width: 2px;
    height: 20px;
    background-color: #ccc; 
    position: absolute;
    right: -10px; 
    top: 50%;
    transform: translateY(-50%);
}

.work-hour-legend {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 15px;
    margin-left: 20px;
}

.work-hour-legend-item {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #555;
    margin-right: 10px;
}

.work-hour-legend-item .work-hour-box {
    width: 12px;
    height: 12px;
    
    background-color: #0033cc;
    margin-right: 5px;
}

.work-hour-box.light-blue {
    background-color: #99ccff;
}

.work-hour-box.gray {
    background-color: #d3d3d3;
}

.work-hour-box.red {
    background-color: #ff4d4d;
}
@media (max-width: 768px) 
{
.work-hour-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: none;
}
}`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/MyDailyWorkHour.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;;AAEf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,aAAa;AACjB;AACA","sourcesContent":[".work-hour-container {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.work-hour-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    margin-bottom: 10px;\n    background-color: #fff;\n}\n\n.work-hour-header h3 {\n    font-size: 1.4rem;\n    text-align: start;\n    font-weight: bold;\n    color: #333;\n    \n}\n\n.work-hour-header span {\n    font-size: 1rem;\n    color: #999; \n}\n\n.work-hour-view-options {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-top: 10px;\n}\n  \n.work-hour-view-options button {\n    background: none;\n    border: none;\n    font-size: 12px;\n    cursor: pointer;\n    padding: 5px 0px;\n    position: relative;\n    transition: color 0.3s ease;\n    color: black;\n}\n  \n.work-hour-view-options button.active {\n    color: #0033cc; \n    font-weight: bold;\n}\n  \n.work-hour-view-options button:not(:last-child)::after {\n    content: \"\";\n    width: 2px;\n    height: 20px;\n    background-color: #ccc; \n    position: absolute;\n    right: -10px; \n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.work-hour-legend {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 15px;\n    margin-left: 20px;\n}\n\n.work-hour-legend-item {\n    display: flex;\n    align-items: center;\n    font-size: 0.9rem;\n    color: #555;\n    margin-right: 10px;\n}\n\n.work-hour-legend-item .work-hour-box {\n    width: 12px;\n    height: 12px;\n    \n    background-color: #0033cc;\n    margin-right: 5px;\n}\n\n.work-hour-box.light-blue {\n    background-color: #99ccff;\n}\n\n.work-hour-box.gray {\n    background-color: #d3d3d3;\n}\n\n.work-hour-box.red {\n    background-color: #ff4d4d;\n}\n@media (max-width: 768px) \n{\n.work-hour-container {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    margin-top: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    display: none;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
